// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { IconIndex } from '../_common/api/IconIndex';
import Icon from '../_common/form/Icon';

const Wrapper = styled(Link)`
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 1.2em;
    margin: 0.1rem 0;
    padding: 0.2rem 0;
    border-radius: 01rem;
    color: ${({ theme, index }) => theme.mobile.homeCards[index]?.text || 'white'};
    background: ${({ theme, index }) => theme.mobile.homeCards[index]?.card || 'black'};
    text-decoration: none;
    box-shadow: 3px 3px 3px 0px ${({ theme }) => theme.mobile.shadow};
    -webkit-touch-callout: none;

    // max-height: 2.7em;

    flex-grow: 1;

    user-select: none;
    &:active {
        opacity: 0.7;
    }
`
const Text = styled.div`
    font-weight: bold;
`
const I = styled(Icon)`
    padding: 0 0.5rem;
    color: ${({ theme, index }) => theme.mobile.homeCards[index]?.icon || 'white'};
`

const HomeCard = ({ to, index, icon, text, ...props }) => {
    return (
        <Wrapper to={to} index={index}>
            <I
                index={index}
                icon={icon}
                size='2x'
                transform='shrink-6.5'
                mask={IconIndex.circle}
            />
            <Text>{text.toUpperCase()}</Text>
        </Wrapper>
    );
}

export default HomeCard;